import logo from "../../../assets/dark-logo.svg";

export default function Challenge() {
  return (
    <>
      <section id="solution">
        <div className="container">
          <div className="row-essy">
            <div className="col-essy-md-6 col-essy-lg-6">
              <div className="solution-single">
                <span>THE PROBLEM</span>
                <h2>
                  The Connection <br /> Is Broken
                </h2>
                <ul>
                  <li>
                    Companies spend months chasing <br /> candidates who never
                    reply.
                  </li>
                  <li>
                    Technical talent gets flooded <br /> with irrelevant
                    outreach.
                  </li>
                  <li>
                    Both sides lose time, <br /> money, and patience.{" "}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-essy-md-6 col-essy-lg-6">
              <div className="solution-single solution-single-right">
                <span>
                  THE <img src={logo} alt="logo" /> SOLUTION
                </span>
                <h2 className="text-dark ">
                  Relevance. <br /> Respect. Results.
                </h2>
                <p className="text-dark ">
                  Essy brings vetted technical-commercial professionals and
                  hiring teams together. Quickly and meaningfully.
                </p>
                <div className="solution-col-inner-wrapper">
                  <div className="solution-col-inner">
                    <h4>For Companies </h4>
                    <p>
                      Join the waitlist to access a curated network of
                      candidates ready to move.
                    </p>
                  </div>
                  <div className="solution-col-inner">
                    <h4>For Candidates</h4>
                    <p>
                      Join the beta to receive only relevant roles from vetted
                      employers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
